var keyMirror = require('keymirror');

module.exports = {
  changeType: {
    CUSTOM_CODE: 'custom_code',
    ATTRIBUTE: 'attribute',
    APPEND: 'append',
    REARRANGE: 'rearrange',
    REDIRECT: 'redirect',
    WIDGET: 'widget',
  },
  DOMInsertionType: {
    AFTER: 'after',
    APPEND: 'append',
    BEFORE: 'before',
    PREPEND: 'prepend',
  },
  insertAdjacentHTMLType: {
    AFTER_BEGIN: 'afterbegin',
    AFTER_END: 'afterend',
    BEFORE_BEGIN: 'beforebegin',
    BEFORE_END: 'beforeend',
  },
  selectorChangeType: {
    CLASS: 'class',
    HTML: 'html',
    HREF: 'href',
    SRC: 'src',
    STYLE: 'style',
    TEXT: 'text',
    HIDE: 'hide',
    REMOVE: 'remove',
  },
  changeApplierState: keyMirror({
    APPLIED: null,
    APPLYING: null,
    UNAPPLIED: null,
    UNDOING: null,
  }),
  changeState: keyMirror({
    BLOCKED: null,
    UNAPPLIED: null,
    APPLIED: null,
    APPLYING: null,
    UNDOING: null,
    TIMED_OUT: null,
    IGNORED: null,
    ERROR: null,
  }),
};
